import { Directive, ElementRef, Renderer2, HostListener, AfterViewInit, Input } from '@angular/core';
import { MagnifyOption, magnyfyOptions } from '@app/shared/directives/magnify/magnify.model';

@Directive({
  selector: '[appMagnify]'
})
export class MagnifyDirective implements AfterViewInit {
  public lensElement;
  public options: MagnifyOption = magnyfyOptions;

  @Input()
  option: MagnifyOption;

  constructor(private element: ElementRef, private render: Renderer2) {}

  ngAfterViewInit() {
    this.options = { ...this.options, ...this.option };
    this.createLens();
  }

  createLens() {
    this.lensElement = this.render.createElement('div');
    this.render.insertBefore(this.element.nativeElement.parentNode, this.lensElement, this.element.nativeElement);
    this.lensElement.addEventListener('mouseover', this.onMouseOver.bind(this), { passive: true });
    this.lensElement.addEventListener('mousemove', this.onMouseMove.bind(this), { passive: true });
    this.lensElement.addEventListener('mouseleave', this.onMouseLeave.bind(this), { passive: true });
  }

  @HostListener('mouseover')
  onMouseOver() {
    this.element.nativeElement.style.cursor = 'none';
    this.lensElement.style.visibility = 'visible';
    this.setlensElementStyle();
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    this.lensElement.style.visibility = 'hidden';
  }

  @HostListener('mousemove', ['$event'])
  onMouseMove(event) {
    // lensElement center : width /2, height/2
    const w = this.lensElement.offsetWidth / 2;
    const h = this.lensElement.offsetHeight / 2;

    // cursor position in img
    const x = event.pageX - this.element.nativeElement.getBoundingClientRect().left - window.pageXOffset;
    const y = event.pageY - this.element.nativeElement.getBoundingClientRect().top - window.pageYOffset;

    // fill lensElement with img zoom
    this.lensElement.style.backgroundPosition =
      '-' + (x * this.options.zoom - w) + 'px -' + (y * this.options.zoom - h) + 'px';

    // set lensElement position
    // left = x + offset de l'image (carousel) - w (centre de la loupe)
    this.lensElement.style.left = x + this.element.nativeElement.offsetLeft - w + 'px';
    this.lensElement.style.top = y - h + 'px';
  }

  public setlensElementStyle() {
    this.lensElement.style.position = 'absolute';
    this.lensElement.style.backgroundImage = `url('${this.element.nativeElement.getAttribute('src')}')`;
    this.lensElement.style.backgroundSize =
      this.element.nativeElement.width * this.options.zoom +
      'px ' +
      this.element.nativeElement.height * this.options.zoom +
      'px';
    this.lensElement.style.backgroundRepeat = this.options.backgroundRepeat;
    this.lensElement.style.height = this.options.height + 'px';
    this.lensElement.style.width = this.options.width + 'px';
    this.lensElement.style.border = this.options.border + 'px solid';
    this.lensElement.style.borderRadius = this.options.borderRadius + '%';
    this.lensElement.style.borderColor = this.options.borderColor;
    this.lensElement.style.cursor = this.options.cursor;
    this.lensElement.style.boxShadow = this.options.boxShadow;
  }
}
